import '@refinitiv-ui/elements/button';
import { CSSResult, LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../components/heimdall-error.js';
import '../components/heimdall-loader.js';
import '../components/login-frame.js';
import { startRedirection } from '@lseg-ciam/auth/login';
import { VERSION } from '@lseg-ciam/auth';

console.log('[HLA] @lseg-ciam/auth', VERSION);
import {
  defaultAudiencesByClientUid,
  knownLinkOrigins,
  workspaceFinalizeLoginHook,
} from '../workspace-config.js';
import { appConfig$ } from '../config.js';
import '../theme.js';

@customElement('heimdall-login')
export class HeimdallLogin extends LitElement {
  @state()
  _error: unknown = null;

  firstUpdated() {
    const redirectUri =
      location.origin + import.meta.env.BASE_URL + '/redirect/index.html';

    appConfig$.subscribe({
      next: ({ issuerUrl, clientUid, idpLookupUrl, pnsSub }) => {
        startRedirection({
          issuerUrl,
          redirectUri,
          clientUid: clientUid ?? 'workspace',
          idpLookupUrl,
          knownLinkOrigins,
          onFinalizeLogin: workspaceFinalizeLoginHook,
          defaultAudiencesByClientUid,
          pnsSub,
        }).catch((error) => {
          this._error = error;
        });
      },
      error: (error) => {
        this._error = error;
      },
    });
  }

  render() {
    return html`<login-frame> ${this.getFrameContent()} </login-frame>`;
  }

  getFrameContent() {
    if (this._error) {
      return html`<heimdall-error .error=${this._error}></heimdall-error>`;
    }

    return html`<heimdall-loader />`;
  }

  static get styles(): CSSResult {
    return css`
      .button {
        margin: 0 10px 10px 0;
      }
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-login': HeimdallLogin;
  }
}
